import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyYoyGrowthPlanningChanges } from '../../api'
import { mapMarketYoyGrowthPlanningToApi } from '../../lib'
import { selectMarketYoyGrowthExpectationState } from '../selectors'

export const requestApplyYoyGrowthPlanningChanges = createAsyncThunk(
  'marketYoyGrowthExpectation/requestApplyYoyGrowthPlanningChanges',
  (_: void, { getState }) => {
    const { planning } = selectMarketYoyGrowthExpectationState(getState())

    if (!planning) {
      throw new Error('Cannot publish market YoY growth planning before planning data has loaded')
    }

    return applyYoyGrowthPlanningChanges(
      mapMarketYoyGrowthPlanningToApi({ ...planning, status: 'Published' })
    )
  },
  {
    condition: (_, { getState }) => {
      const { isSaving } = selectMarketYoyGrowthExpectationState(getState())

      return !isSaving
    },
  }
)
